import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';

import { Country } from '../../shared/country.model';
import { CountryService } from '../../shared/country.service';

@Component({
  selector: 'app-country-translation-modal',
  templateUrl: './country-translation-modal.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class CountryTranslationModalComponent {
  constructor(
    private countryService: CountryService,
    private ref: MatDialogRef<CountryTranslationModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getCountry();
  }

  country: Country = null;

  modalTitle = this.data.title;
  countryId = this.data.obj.id;
  language = this.data.params.language;

  onCanceled() {
    this.close();
  }

  close() {
    this.ref.close();
  }

  private getCountry() {
    let params = {
      get: 'translate',
      lang: this.language.lang,
    };

    this.countryService.getCountry(this.countryId, params).subscribe((country) => {
      this.country = country;
    });
  }
}
